import { makeAutoObservable } from "mobx"
import { nanoid } from "nanoid"

import { DataSourcesListMeta } from "@framework/types/upload"

export default class SimpleCollectionStore<T extends Record<string, any>> {
  constructor() {
    makeAutoObservable(this)
  }

  id = nanoid()

  isLoading = false

  error: string | null = null

  data: T[] = []

  total = 0

  get totalLoaded(): number {
    return this.data.length
  }

  setData = (data: T[], meta: Partial<DataSourcesListMeta> = {}) => {
    const { pageNum = 0, pageSize = data.length, total = data.length } = meta

    const startIdx = pageNum * pageSize
    const stopIdx = startIdx + data.length

    const newArray = this.data.slice(0, total)
    newArray.splice(startIdx, stopIdx, ...data)

    this.data = newArray
    this.total = total
  }

  setLoading = (value: boolean) => {
    this.isLoading = value
  }

  resetData = () => {
    this.data = []
  }

  get getByIndex() {
    const { data } = this
    return (index: number) => data[index] ?? null
  }
}
